import { CompanyManager } from "./CompanyManager"

export default CompanyManager
